import { Entity } from '@backstage/catalog-model';

export const GITLAB_SLUG_ANNOTATION = 'gitlab.com/project-slug';
export const MANIFEST_PATHS_ANNOTATION = 'dependency-viewer/manifest-paths';

export function isGitlabSlugAvailable(entity: Entity): boolean {
  const annotation =
    entity.metadata.annotations?.[GITLAB_SLUG_ANNOTATION];
  if (!annotation) return false;
  return annotation.trim().length > 0;
}

export function getSlugFromEntity(entity: Entity): string | null {
  const annotation =
    entity.metadata.annotations?.[GITLAB_SLUG_ANNOTATION];
  if (!annotation || annotation.trim().length === 0) return null;
  return annotation;
}

/**
 * Reads the optional `dependency-viewer/manifest-paths` annotation.
 * Format: comma-separated list of paths, e.g. "services/api,services/worker,libs/shared"
 * Returns an array of trimmed paths, or empty array if not set.
 */
export function getManifestPathsFromEntity(entity: Entity): string[] {
  const annotation =
    entity.metadata.annotations?.[MANIFEST_PATHS_ANNOTATION];
  if (!annotation || annotation.trim().length === 0) return [];
  return annotation.split(',').map(p => p.trim()).filter(p => p.length > 0);
}
